export default __webpack_public_path__ + "static/media/fad-redo.82f2e578.svg";